import { supabase } from './supabaseClient';

/**
 * Unified app logout helper.
 * - Attempts Supabase signOut
 * - Then redirects to provided path (defaults to "/login")
 * - If a navigate function is provided (from react-router), it will be used; otherwise falls back to window.location
 * - Returns true on success, false on error
 */
export async function appLogout(redirectPath = '/login', { navigate, replace = true } = {}) {
  try {
    await supabase.auth.signOut();
  } catch (e) {
    // Swallow errors but return false to allow callers to show a message if desired
    try { console.warn('Sign out failed (continuing to redirect):', e?.message || e); } catch {}
  }

  try {
    if (typeof navigate === 'function') {
      navigate(redirectPath, { replace });
    } else if (typeof window !== 'undefined' && window.location) {
      window.location.assign(redirectPath);
    }
  } catch {}

  return true;
}
